import * as React from "react";
import Box from "@mui/joy/Box";

function Main(props) {
  return (
    <Box
      component="main"
      className="Main"
      {...props}
      sx={[{ p: 2 }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}
    />
  );
}

const Layout = {
  Main,
};
export default Layout;
